import AppState, { SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Texts from 'react-sdk/Texts';
import classes from './EmailSent.module.css';

import { FaCheck } from 'react-icons/fa6';


const EmailSent = ({email, onCodeLogin}) => {

  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  function handleSubmitCode(e) {
    e.preventDefault()
    setSubmitting(true)
    AppState.loginWithCode(email, code)
    .then(() => onCodeLogin?.())
    .catch(err =>{
      setSubmitting(false)
      console.log("err", err)
      setError("Erreur login code")
    })


  }

  function handleChangeCode(e) {
    setError(null)
    setCode(e.target.value.toUpperCase())
  }

  return (
    <div className={classes.EmailSent}>

      <h1
      className={classes.title}
      dangerouslySetInnerHTML={{__html: Texts.get("mailsent-title") }} />


      <div
      className={classes.descr}
      dangerouslySetInnerHTML={{__html: Texts.get("mailsent-descr") }}/>

      {/* <h2>{Texts.get("mailsent-or")}</h2> */}

      <form className={classes.form} onSubmit={handleSubmitCode}>
        <input type="text" value={code} placeholder={Texts.get("mailsent-code-placeholder")}
        onChange={handleChangeCode}/>
        {error &&
        <div className={classes.error}>{error}</div>}
        <div className={classes.form_button_ctnr} >
          <Button disabled={submitting || !code} >{Texts.get("mailsent-btn-valid")}</Button>
        </div>
      </form>

    </div>

  );
};

export default  observer(EmailSent)
